import React, { useState } from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/navbar/Navbar.js';
import Banner from '../components/Banner.js';
import banner from '../images/energymanagment/banner.webp';
import shelly from '../images/energymanagment/shelly.jpeg';
import video1000 from '../images/energymanagment/v1000.mp4';
import pic1 from '../images/energymanagment/pic1.png';
import pic2 from '../images/energymanagment/pic2.png';
import pic3 from '../images/energymanagment/pic3.png';
import { useSEO } from '../components/CustomHook';

const EnergyManagement = () => {
    useSEO(
        "Energiemanagement - Sigen AI Intelligente Steuerung | Schmid Energieberatung",
        "Intelligentes Energiemanagement mit Sigen AI. Optimieren Sie Eigenverbrauch, nutzen Sie günstige Strompreise und steuern Sie Ihr Energiesystem per App.",
        "Energiemanagement, Sigen AI, Smart Energy, Eigenverbrauch optimieren, dynamische Strompreise, Energiesteuerung",
        "/images/products/energiemanagement.webp"
    );

    return (
        <div className="overflow-x-hidden">
            <Navbar />
            <Banner
                imageSrc={banner}
                title="Energiemanagement"
                subtitle="Alles im Griff – sogar den Strompreis"
                description="Ein modernes Energiemanagementsystem vernetzt alle Elemente Ihrer Solaranlage – von der PV-Anlage über den Speicher bis hin zu Verbrauchergeräten – smart und effizient. So wird nicht nur Ihre Eigenversorgung optimiert, sondern auch Ihre Energiekosten spürbar gesenkt. Dank der dynamischen Preissignalfunktion erkennt das System günstige Stromtarife und lädt den Speicher gezielt dann, wenn der Strom am billigsten ist. Mehr Kontrolle, mehr Einsparung – vollautomatisch."
            />


            {/* Grid Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 grid-rows-3 gap-8">
                    {/* Box 1: Reihe 1, Spalte 1 */}
                    <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl" style={{ backgroundImage: `url(${shelly})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <h3 className="text-xl font-bold text-center mb-4">Shelly jetzt mit<br />Sigenergy kompatibel</h3>
                        <p className="text-center mb-4 text-white" style={{
                                    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)'
                                }}>Die beliebten Shelly-Smart-<br />Schalter lassen sich jetzt<br />mühelos in das Sigenergy-Smart-<br />Home integrieren.</p>
                    </div>

                    {/* Box 2: Reihe 1, Spalte 2 & 3 */}
                    <div className="bg-primary rounded-xl flex flex-col items-center justify-center p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl md:col-span-2 md:col-start-2">
                        <h3 className="text-xl font-bold text-center mb-4 text-white">Stromverbrauch intelligent reduzieren</h3>
                        <p className="text-center mb-4 text-white">Sigen.Ai optimiert den Energiefluss in Ihrem<br />Zuhause. Durch gezielte Steuerung vermeiden Sie<br />unnötigen Verbrauch – für dauerhaft niedrigere<br />Stromkosten.</p>
                    </div>

                    {/* Box 3: Reihe 1, Spalte 4 */}
                    <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl">
                        <h3 className="text-xl font-bold text-center mb-4">Volle Kontrolle per<br />App</h3>
                        <p className="text-center mb-4">Überwachen und steuern<br />Sie Ihr gesamtes<br />Energiesystem bequem<br />per Smartphone – mit der<br />intuitiven Sigen.Ai App,<br />jederzeit und von überall.</p>
                    </div>

                    {/* Box 4: Reihe 2, Spalte 1, 2 & 3 */}
                    <div className="bg-secondary-light rounded-xl flex flex-col items-center justify-center p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl md:col-span-3 md:row-start-2">
                        <h3 className="text-xl font-bold text-center mb-4">Strom zum besten Preis laden Preisdynamik</h3>
                        <p className="text-center mb-4">Dank Preissignalfunktion erkennt das System günstige Zeitfenster am<br />Strommarkt. Ihr Speicher lädt automatisch dann, wenn der Strom besonders<br />günstig ist.</p>
                    </div>

                    {/* Box 5: Reihe 3, Spalte 1, 2 & 3 */}
                    <div className="bg-primary rounded-xl flex flex-col items-center justify-center p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl md:col-span-3 md:row-start-3">
                        <h3 className="text-xl font-bold text-center mb-4 text-white">Zukunftssicher & flexibel erweiterbar</h3>
                        <p className="text-center mb-4 text-white">Ob Wärmepumpe, Speicher oder neue Smart-Energy-Lösungen – Sigen.Ai<br />ist auf kommende Anforderungen vorbereitet und jederzeit modular<br />erweiterbar.</p>
                    </div>

                    {/* Box 6: Reihe 2 & 3, Spalte 4 */}
                    <div className="bg-primary rounded-xl flex flex-col items-center justify-center p-6 transition-all duration-300 hover:scale-105 hover:shadow-2xl md:row-span-2 md:col-start-4 md:row-start-2">
                        <h3 className="text-xl font-bold text-center mb-4 text-white">Solarstrom für Ihr E-<br />Auto</h3>
                        <p className="text-center mb-4 text-white">Mit Sigen.Ai wird Ihre Wallbox<br />bevorzugt mit Solarstrom vom<br />eigenen Dach versorgt. So<br />fahren Sie günstiger und<br />nachhaltiger.</p>
                    </div>
                </div>
            </div>

            {/* Text Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="p-8 md:p-12">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-primary">
                        Das smarte Gehirn Ihrer Energiezentrale: die Sigen Ai
                    </h2>
                    <div className="text-lg text-gray-700 leading-relaxed">
                        <p className="mb-4">
                            Im Zentrum Ihres modernen Energiesystems arbeitet die kompakte Sigen Ai.
                        </p>
                        <p className="mb-4">
                            Ausgestattet mit hochentwickelter Mikrochiptechnologie sorgt sie dafür, dass alle
                            Komponenten – von der PV-Anlage über den Stromspeicher bis hin zur Wärmepumpe oder
                            Wallbox – nahtlos miteinander kommunizieren.
                        </p>
                        <p>
                            Das Ergebnis: Ein perfekt abgestimmtes System, das Energie intelligent verteilt, effizient
                            nutzt und Ihre Unabhängigkeit maximiert.
                        </p>
                    </div>
                </div>
            </div>

            {/* Video and Text Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="p-8 md:p-12">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-primary">
                        Preissignalfähigkeit & Sigen Ai
                    </h2>
                    <div className="flex flex-col md:flex-row gap-8 items-center">
                        <div className="md:w-1/2">
                            <video
                            className="w-full h-auto rounded-lg shadow-md"
                            autoPlay
                            loop
                            muted
                            playsInline
                            >
                                <source src={video1000} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                        <div className="md:w-1/2">
                            <h3 className="text-xl font-bold mb-4 text-gray-800">
                                Strom laden, wenn er am günstigsten ist<br />
                            </h3>
                            <div className="text-lg text-gray-700 leading-relaxed">
                                <p className="mb-4">
                                    In Verbindung mit Sigen Ai zählt der Sigenergy
                                    Speicher zu den smartesten Energiespeichern am Markt.
                                </p>
                                <p className="mb-4">
                                    In Kombination mit einem dynamischen Stromtarif
                                    analysiert das System automatisch die Preissignale der
                                    „EPEX SPOT Day-Ahead“-Börse und passt das
                                    Ladeverhalten entsprechend an.
                                </p>
                                <p className="mb-4">
                                    Liegt der Strompreis niedrig, lädt der Speicher gezielt zu diesen
                                    Zeiten – ideal für Nachtstunden oder sonnenarme
                                    Wintertage, wenn Ihre PV-Anlage wenig oder keinen
                                    Strom erzeugt.
                                </p>
                                <p>
                                    Das senkt Ihre Stromkosten, erhöht Ihre Flexibilität
                                    und macht Sie unabhängiger vom Energiemarkt.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Additional Text Box */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-primary">
                        Sehen, verstehen, vorausdenken – mit Sigen AI Insight
                    </h2>
                    <div className="text-lg text-gray-700 leading-relaxed">
                        <p className="mb-4">
                            Sigen AI Insight macht Ihre Energiestrategie transparent: Sie sehen genau, wie Ihr System in den letzten 24
                            Stunden gearbeitet hat – wann es geladen, entladen oder Strom aus dem Netz bezogen hat, und warum.
                        </p>
                        <p className="mb-4">
                            Gleichzeitig erhalten Sie einen präzisen Ausblick auf die kommenden 24 Stunden. KI-gestützte Prognosen
                            erklären jede geplante Aktion Ihres Systems und geben Ihnen die volle Kontrolle.
                        </p>
                        <p className="mb-4">
                            Günstiger Strom – ganz automatisch
                        </p>
                        <p className="mb-4">
                            Dank der „EPEX SPOT Day-Ahead“-Preiskurve der europäischen Strombörse lädt Ihr System genau dann
                            Strom, wenn er besonders günstig ist – häufig sogar zum Nulltarif oder darunter. Die Preise werden täglich im
                            Viertelstundentakt veröffentlicht und machen es möglich, Ihre Energiekosten gezielt zu senken.
                        </p>
                        <p>
                            Das ist Energietransparenz, angetrieben von Intelligenz – damit Sie informiert bleiben, Kosten sparen und immer
                            einen Schritt voraus sind.
                        </p>
                    </div>
                </div>
            </div>

            {/* Features Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">
                    Weitere Features
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {/* Feature 1 */}
                    <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl border border-gray-100">
                        <div className="bg-primary w-12 h-12 rounded-lg flex items-center justify-center mb-6">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold mb-4 text-gray-800">
                            Intelligente Messsysteme – für volle Kontrolle
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                            Mit dem Smart Meter und Sigen.Ai wird Ihr Energieverbrauch transparent und steuerbar.
                            Dynamische Netzentgelte und Tarife machen Strom günstiger, wenn die Netzauslastung
                            niedrig ist.<br /><br />
                            Ab 2026: Möglichkeit zur direkten Stromvermarktung – mit attraktiven
                            Einspeisevergütungen für Ihren eigenen PV-Strom.
                        </p>
                    </div>

                    {/* Feature 2 */}
                    <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl border border-gray-100">
                        <div className="bg-primary w-12 h-12 rounded-lg flex items-center justify-center mb-6">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold mb-4 text-gray-800">
                            Dynamische Stromtarife – bereit für die Zukunft
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                            Sigen.Ai ist voll kompatibel mit allen dynamischen Stromtarifen, die auf dem EPEX-
                            Spotmarkt basieren. Ab 2025 sind Energieversorger gesetzlich verpflichtet, solche Tarife
                            anzubieten. Sie profitieren automatisch von niedrigen Preisen – ganz ohne Mehraufwand.
                        </p>
                    </div>

                    {/* Feature 3 */}
                    <div className="bg-gradient-to-br from-white to-gray-50 rounded-2xl shadow-xl p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl border border-gray-100">
                        <div className="bg-primary w-12 h-12 rounded-lg flex items-center justify-center mb-6">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                        </div>
                        <h3 className="text-xl font-bold mb-4 text-gray-800">
                            mySigen App
                        </h3>
                        <p className="text-gray-600 leading-relaxed">
                            Ihr Energiesystem – smart gesteuert, überall dabei<br />
                            Mit der mySigen App steuern und überwachen Sie alle Komponenten Ihres Energiesystems
                            bequem per Smartphone. Ob Stromerzeugung, Verbrauch, Speicherstand oder Wallbox – alle
                            Daten sind in Echtzeit in der Cloud abrufbar.<br /><br />
                            Passen Sie Einstellungen ganz einfach an – z. B. wann Ihr Speicher bei günstigen
                            Strompreisen geladen wird. Intuitiv, übersichtlich und jederzeit einsatzbereit – Ihre
                            Energie, unter Ihrer Kontrolle.
                        </p>
                    </div>
                </div>
            </div>

            {/* Interactive Image Section */}
            <InteractiveImageSection />

            {/* Additional Text Section */}
            <div className="w-full max-w-7xl mx-auto py-16 px-8">
                <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
                    <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-primary">
                        Unser Energiekonzept – alles aus einer Hand
                    </h2>
                    <div className="text-lg text-gray-700 leading-relaxed">
                        <p className="mb-4">
                            Von der <strong>individuellen Beratung</strong> bis zur <strong>fertig installierten Solaranlage mit Speicher</strong>: Mit
                            dem Energiekonzept der <strong>Schmid Energieberatung GmbH</strong> kümmern wir uns um alles – Sie
                            lehnen sich einfach zurück.
                        </p>
                        <p className="mb-4">
                            Wir begleiten Sie von Anfang an:
                        </p>
                        <ul className="list-none mb-4">
                            <li className="mb-2">✔ Persönliche Beratung bei Ihnen vor Ort</li>
                            <li className="mb-2">✔ Detaillierte Planung nach Ihren Wünschen</li>
                            <li className="mb-2">✔ Auswahl hochwertiger Komponenten</li>
                            <li className="mb-2">✔ Fachgerechte Installation durch zertifizierte Meisterbetriebe</li>
                            <li className="mb-2">✔ Abnahme durch Elektriker und Anmeldung beim Netzbetreiber</li>
                        </ul>
                        <p className="mb-4">
                            Auch nach der Inbetriebnahme sind wir für Sie da:
                        </p>
                        <ul className="list-none mb-4">
                            <li className="mb-2">✔ Einrichtung des Energiemanagement-Systems</li>
                            <li className="mb-2">✔ Wartung, Monitoring und schnelle Hilfe bei Störungen</li>
                            <li className="mb-2">✔ Optional: Reinigungsservice, Garantieabwicklung, Reparaturmanagement</li>
                        </ul>
                        <h3 className="text-xl font-bold mt-8 mb-4 text-primary">
                            Kostenlose PV-Beratung
                        </h3>
                        <p className="mb-4 font-bold">
                            Ihr Weg zur eigenen Solaranlage beginnt hier
                        </p>
                        <p className="mb-4">
                            Lassen Sie sich <strong>kostenlos und unverbindlich</strong> von unseren Experten beraten – persönlich,
                            ehrlich und auf Ihre Situation abgestimmt.
                        </p>
                        <ul className="list-none mb-4">
                            <li className="mb-2">• <strong>Individuelle Einschätzung</strong> Ihrer Dachfläche & Energiebedarfs</li>
                            <li className="mb-2">• <strong>Rückruf durch einen Fachberater</strong> – direkt aus unserer Region</li>
                            <li className="mb-2">• <strong>Transparente Informationen</strong> zu Technik, Wirtschaftlichkeit & Förderung</li>
                        </ul>
                        <p className="text-center font-bold mt-8">
                            Schmid Energieberatung GmbH – Ihre Energielösung aus Meisterhand
                        </p>
                        <div className="flex justify-center mt-8">
                            <a
                                href="/contact"
                                className="bg-primary text-white rounded-lg font-semibold text-base px-8 py-4 lg:px-10 lg:py-5 transition-all duration-200 hover:scale-105"
                            >
                                Beratung vereinbaren
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default EnergyManagement;

const InteractiveImageSection = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const images = [
    {
      src: pic1,
      title: "Transparenz auf einen Blick – mit dem einzigartigen Energieflussdiagramm",
      description:
        "Erleben Sie das branchenweit erste Energieflussdiagramm, das nicht nur Mengen, sondern auch Herkunft und Ziel Ihres Stroms darstellt. Das intuitive Sankey-Diagramm visualisiert dynamisch jeden Energiepfad in Ihrem System – klar nachvollziehbar nach Weg, Anteil und Verbrauch. Dabei werden sechs Energiequellen und fünf Verbrauchskategorien präzise abgebildet. So erhalten Sie eine detaillierte Übersicht über die Lastverteilung, erkennen Optimierungspotenziale, reduzieren Verluste und treffen fundierte Entscheidungen für mehr Effizienz.",
    },
    {
      src: pic2,
      title: "Batterieenergiequelle – volle Transparenz über Ihre gespeicherte Energie",
      description:
        "Die Funktion \"Batterieenergiequelle\" bietet Ihnen einzigartige Einblicke in die Herkunft Ihrer gespeicherten Energie und macht deren Umweltfreundlichkeit messbar. Sie sehen nicht nur den aktuellen Ladezustand (SOC) Ihrer Batterie, sondern auch die genaue Zusammensetzung der gespeicherten Energie. Ob Photovoltaik, externe Wechselrichter, EV-DC-Module, Generatoren oder Netzimporte – sämtliche Energiemengen werden in kWh und Prozenten klar ausgewiesen. Dank automatischer Aktualisierung alle 10 Sekunden erhalten Sie jederzeit ein präzises, nahezu sekundengenaues Bild Ihrer Energiezusammensetzung.",
    },
    {
      src: pic3,
      title: "Energiequelle auf Geräteebene – Transparenz bis ins Detail",
      description:
        "Mit unserem System überwachen Sie nicht nur Ihr gesamtes Energiebudget. Der wahre Unterschied liegt in der einzigartigen Möglichkeit, den exakten Energiemix jedes einzelnen Smart-Geräts in Ihrem Zuhause nachzuvollziehen – ob Solarstrom, Batteriestrom oder Netzenergie. So sehen Sie zum Beispiel auf einen Blick, wie viel Solarenergie Ihre Klimaanlage im Vergleich zur Batterie im letzten Zyklus genutzt hat. Diese branchenweit erste Detailtiefe verschafft Ihnen ein völlig neues Verständnis und eröffnet die Chance, Ihren Energieverbrauch noch gezielter und intelligenter zu steuern.",
    },
  ];

  return (
    <div className="w-full max-w-7xl mx-auto py-16 px-8">
      <h2 className="text-3xl font-bold text-center mb-12 text-primary">
        Intuitiver
      </h2>

      {/* Mobile + Tablet (<1280px) */}
      <div className="flex flex-col gap-12 xl:hidden">
        {images.map((image, index) => (
          <div key={index} className="flex flex-col gap-4">
            <div className="relative overflow-hidden rounded-xl shadow-lg w-full">
              <img
                src={image.src}
                alt={image.title}
                className="w-full h-auto object-cover"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-gray-800 leading-snug mb-2">
                {image.title}
              </h3>
              <p className="text-gray-700 text-lg leading-[1.6]">
                {image.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop (≥1280px) */}
      <div
        className="hidden xl:flex flex-col xl:flex-row gap-8 relative min-h-[600px]"
        onMouseLeave={() => setHoveredIndex(null)}
      >
        {/* Bilder */}
        <div className="flex gap-6 w-full">
          {images.map((image, index) => (
            <div
              key={index}
              className={`transition-all duration-500 ease-in-out transform ${
                hoveredIndex === null
                  ? "w-1/3"
                  : hoveredIndex === index
                  ? "w-1/3"
                  : "w-0 opacity-0 overflow-hidden"
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
              style={{
                flexShrink: 0,
                transitionProperty: "width, opacity, transform",
              }}
            >
              <div className="relative overflow-hidden rounded-xl shadow-lg w-full h-full">
                <img
                  src={image.src}
                  alt={image.title}
                  className="w-full h-full object-cover cursor-pointer transition-transform duration-500 ease-in-out"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-6">
                  <h3 className="text-white text-2xl font-bold">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Text */}
        <div
          className={`absolute right-0 top-0 bottom-0 w-[60%] transition-all duration-500 ease-in-out transform ${
            hoveredIndex !== null
              ? "translate-x-0 opacity-100"
              : "translate-x-full opacity-0"
          }`}
        >
          {hoveredIndex !== null && (
            <div className="h-full flex flex-col justify-center pl-4 pr-6">
              <h3 className="text-3xl font-bold mb-4 text-gray-800 leading-snug">
                {images[hoveredIndex].title}
              </h3>
              <p className="text-gray-700 text-lg leading-[1.6]">
                {images[hoveredIndex].description}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};